/* Noromega – handlekurv: abonnement av/på, anbefalinger og rabattkode */
(function () {
  if (window.nmCartReady) return;
  window.nmCartReady = true;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function update(path, body, btn) {
    var drawer = document.querySelector('cart-drawer');
    body.sections = 'cart-drawer,cart-icon-bubble';
    body.sections_url = window.location.pathname;
    if (btn) btn.disabled = true;
    return fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (state.status && state.description) {
          if (btn) { btn.disabled = false; btn.textContent = state.description; }
          return null;
        }
        if (!drawer) { window.location.href = root + 'cart'; return null; }
        drawer.classList.remove('is-empty');
        drawer.renderContents(state);
        if (window.publish && window.PUB_SUB_EVENTS) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'nm-cart', cartData: state });
        return state;
      })
      .catch(function () { if (btn) btn.disabled = false; return null; });
  }

  function applyCode(code, btn) {
    var msgBefore = document.querySelector('[data-nm-code-msg]');
    if (msgBefore) msgBefore.textContent = '';
    return update('cart/update.js', { discount: code }, btn).then(function (state) {
      if (!state || !code) return;
      var hit = (state.discount_codes || []).filter(function (d) { return d.code.toUpperCase() === code.toUpperCase(); })[0];
      if (hit && hit.applicable === false) {
        /* Fjern koden som ikke gjelder, og forklar hvorfor */
        update('cart/update.js', { discount: '' }).then(function () {
          setTimeout(function () {
            var t = document.querySelector('.nm-code__toggle');
            if (t) t.open = true;
            var m = document.querySelector('[data-nm-code-msg]');
            if (m) m.textContent = (document.documentElement.lang || '').indexOf('en') === 0 ? 'The code "' + code + '" doesn\'t apply to this cart.' : 'Koden «' + code + '» gjelder ikke for denne handlekurven.';
          }, 120);
        });
      }
    });
  }

  document.addEventListener('click', function (e) {
    var up = e.target.closest('[data-nm-upgrade]');
    if (up) {
      e.preventDefault();
      update('cart/change.js', { id: up.dataset.key, quantity: Number(up.dataset.qty), selling_plan: up.dataset.plan ? Number(up.dataset.plan) : null }, up);
      return;
    }
    var add = e.target.closest('[data-nm-rec-add]');
    if (add) {
      e.preventDefault();
      update('cart/add.js', { items: [{ id: Number(add.dataset.variant), quantity: 1 }] }, add);
      return;
    }
    var apply = e.target.closest('[data-nm-code-apply]');
    if (apply) {
      e.preventDefault();
      var input = document.querySelector('[data-nm-code-input]');
      var code = input ? input.value.trim() : '';
      if (code) applyCode(code, apply);
      return;
    }
    var remove = e.target.closest('[data-nm-code-remove]');
    if (remove) {
      e.preventDefault();
      update('cart/update.js', { discount: '' }, remove);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-nm-code-input]')) {
      e.preventDefault();
      var btn = document.querySelector('[data-nm-code-apply]');
      if (btn) btn.click();
    }
  });
})();
